import {Grid, IconButton, Menu, MenuItem} from '@material-ui/core';
import {OptionsIcon} from '@treez-ui/core/icons';
import {Title} from '@treez-ui/core/layout';
import {TitleSize} from '@treez-ui/core/layout/Title';
import React, {FunctionComponent, useState} from 'react';

interface Props {
    handleExport: () => void;
}

export const OrgCatalogHeader: FunctionComponent<Props> = (props: Props) => {
    const {handleExport} = props;

    const [optionsAnchorElement, setOptionsAnchorElement] = useState<HTMLElement | null>(null);

    const handleOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
        setOptionsAnchorElement(event.currentTarget);
    };

    const handleOptionsClose = () => {
        setOptionsAnchorElement(null);
    };

    const handleExportsWrapper = () => {
        handleExport();
        setOptionsAnchorElement(null);
    };

    return (
        <Grid className="headline">
            <Title size={TitleSize.MEDIUM} text="Central Catalog" />
            <IconButton
                aria-controls="options-menu"
                aria-haspopup="true"
                onClick={handleOptionsClick}
            >
                <OptionsIcon />
            </IconButton>
            <Menu
                anchorEl={optionsAnchorElement}
                id="options-menu"
                onClose={handleOptionsClose}
                open={Boolean(optionsAnchorElement)}
            >
                <MenuItem onClick={handleExportsWrapper}>CSV Export</MenuItem>
            </Menu>
        </Grid>
    );
};

export default OrgCatalogHeader;
